import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./homechangetext.css";

gsap.registerPlugin(ScrollTrigger);

const HomeColourChangeText = ({ title1, title2, para }) => {
  const textRef = useRef(null);
  const title1Ref = useRef(null);
  const title2Ref = useRef(null);
  const paraRef = useRef(null);

  useEffect(() => {
    gsap.to(textRef.current, {
      backgroundSize: "100% 100%",
      duration: 0.5,
      scrollTrigger: {
        trigger: textRef.current,
        start: "top 80%",
        toggleActions: "play none none none",
      },
    });
  }, []);

  return (
    <div
      ref={textRef}
      className="homechangetext-colourBox lg:max-w-screen-lg my-4"
    >
      <h2 >
        <span>{title1}</span>
      </h2>
      <h3 className="my-0.5">
        <span>{title2}</span>
      </h3>
      <p  >
        <span>{para}</span>
      </p>
    </div>
  );
};

export default HomeColourChangeText;
